// extracted by mini-css-extract-plugin
module.exports = {"chart":"ChartCanvas_chart__1TehE","heading":"ChartCanvas_heading__2L_gy","frame":"ChartCanvas_frame__1TVu1"};